export const TYPE_COLORS = {
  Challenge: "bg-rose-500/15 text-rose-700 dark:text-rose-300",
  Rhetorical: "bg-sky-500/15 text-sky-700 dark:text-sky-300",
  Lament: "bg-indigo-500/15 text-indigo-700 dark:text-indigo-300",
  "Genuine Inquiry": "bg-teal-500/15 text-teal-700 dark:text-teal-300",
  "Wonder/Awe": "bg-teal-500/15 text-teal-700 dark:text-teal-300",
  Deliberative: "bg-cyan-500/15 text-cyan-700 dark:text-cyan-300",
  Probing: "bg-rose-500/15 text-rose-700 dark:text-rose-300",
  Rebuking: "bg-red-500/15 text-red-700 dark:text-red-300",
  Corrective: "bg-rose-500/15 text-rose-700 dark:text-rose-300",
  "Cross-Examination": "bg-fuchsia-500/15 text-fuchsia-700 dark:text-fuchsia-300",
  Accusatory: "bg-red-500/15 text-red-700 dark:text-red-300",
  Complaint: "bg-indigo-500/15 text-indigo-700 dark:text-indigo-300",
  Instructional: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  Invitational: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  "Request/Petition": "bg-lime-500/15 text-lime-700 dark:text-lime-300",
  Intercessory: "bg-lime-500/15 text-lime-700 dark:text-lime-300",
  "Self-Reflective": "bg-violet-500/15 text-violet-700 dark:text-violet-300",
  "Divine Initiative": "bg-yellow-500/15 text-yellow-700 dark:text-yellow-300",
  Prophetic: "bg-purple-500/15 text-purple-700 dark:text-purple-300",
  "Wisdom/Philosophical": "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
};
